import { Button, Group, Modal, Pill, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconTrash as IconDelete } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useRemoveAlias } from '@/module/Dashboard/model/DashboardQuery';

import { useDelete } from '@feature/utils';

interface AliasPillProps {
  alias: string;
}

export function AliasPill(props: AliasPillProps) {
  const { alias } = props;
  const [opened, { open, close }] = useDisclosure(false);
  const { t } = useTranslation();
  const mutation = useRemoveAlias({ alias });
  const { isDeleting, onDelete } = useDelete({ mutation, navigateTo: null });

  return (
    <>
      <Pill
        withRemoveButton
        onRemove={open}
        key={alias}
      >
        {alias}
      </Pill>
      <Modal
        opened={opened}
        onClose={close}
        title={t('profile.removeAliasConfirm.title')}
        centered
      >
        <Stack>
          <Text
            style={{ textAlign: 'center' }}
            fw="500"
          >
            {t('profile.removeAliasConfirm.content')}
          </Text>
          <Group justify="flex-end">
            <Button
              variant="outline"
              onClick={close}
              loading={isDeleting}
            >
              {t('button.cancel')}
            </Button>
            <Button
              onClick={onDelete}
              bg="red"
              loading={isDeleting}
              leftSection={<IconDelete size={16} />}
            >
              {t('button.delete')}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}
